<template>
    <div class="checkbox-wrapper" @click="changeValue">
        <span class="title">{{title}}</span>
        <div
            class="box"
            :class="{'no-value': value === null, 'true': value === true, 'false': value === false}"
        ></div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        value: {
            validator: prop => typeof prop === 'boolean' || prop === null,
        },
    },
    methods: {
        changeValue() {
            if (this.value === null) this.$emit('input', true)
            if (this.value === true) this.$emit('input', false)
            if (this.value === false) this.$emit('input', null)
        },
    },
}
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
    height: 40 * $rem;
    background-color: #fff;
    display: flex;
    cursor: pointer;
    width: 197 * $rem;
    align-items: center;
    padding-left: 15 * $rem;
    border: 1 * $rem solid #b4b4b4;
    border-radius: 5 * $rem;

    span.title {
        color: #464646;
        font-size: 15 * $rem;
    }

    .box {
        height: 18 * $rem;
        width: 18 * $rem;
        border: 1 * $rem solid #a7a7a7;
        margin-left: auto;
        margin-right: 15 * $rem;
        position: relative;
        border-radius: 3 * $rem;

        &.no-value {
            &:before {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                content: '';
                width: 10 * $rem;
                height: 3 * $rem;
                background-color: #797979;
            }
        }

        &.true {
            border: 1 * $rem solid $green-main;
            &:before {
                position: absolute;
                top: 1 * $rem;
                left: 0;
                right: 0;
                margin: auto;
                content: '';
                width: 4 * $rem;
                height: 8 * $rem;
                border-bottom: 3 * $rem solid $green-main;
                border-right: 3 * $rem solid $green-main;
                transform: rotateZ(30deg);
            }
        }

        &.false {
            border: 1 * $rem solid $red;
            &:before {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                content: '';
                width: 12 * $rem;
                height: 2 * $rem;
                background-color: $red;
                transform: rotateZ(45deg);
            }

            &:after {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                content: '';
                width: 12 * $rem;
                height: 2 * $rem;
                background-color: $red;
                transform: rotateZ(-45deg);
            }
        }
    }
}
</style>
